module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Headphones-883da875cff477615d8c2a1e503dc7a3.svg";